module.exports = __webpack_public_path__ + "img/upload_barra.55d9ac3a.svg";